import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);
const CACHED = "stride_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setUser(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem(CACHED, JSON.stringify(r.data));
    }).catch((err) => {
      // offline: keep working with the cached profile; only a real rejection signs out
      const cached = localStorage.getItem(CACHED);
      if (!err.response && cached) { setUser(JSON.parse(cached)); return; }
      localStorage.removeItem("token");
      localStorage.removeItem(CACHED);
      setUser(false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.access_token);
    localStorage.setItem(CACHED, JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem(CACHED);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
